import { render, staticRenderFns } from "./Artefato.vue?vue&type=template&id=eecd725e&scoped=true"
import script from "./Artefato.vue?vue&type=script&lang=js"
export * from "./Artefato.vue?vue&type=script&lang=js"
import style0 from "./Artefato.vue?vue&type=style&index=0&id=eecd725e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eecd725e",
  null
  
)

export default component.exports